// Warehouse constants
export const WAREHOUSE_UNITS = ['ml', 'gr', 'kg', 'τεμάχια', 'κουτιά', 'χάπια', 'φιάλες', 'σακούλες', 'δόσεις'];
export const WAREHOUSE_CATEGORIES = ['Φάρμακα', 'Εξοπλισμός', 'Τροφές', 'Αναλώσιμα', 'Εμβόλια', 'Άλλο'];
